export enum ExtendedFieldDataTypes {
  STRING = "string",
  DATE_TIME = "dateTime",
  INT = "int",
  DECIMAL = "decimal",
  BOOLEAN = "boolean",
  CUSTOM = "custom",
}

export enum AdditionalInfoDataTypes {
  STRING = "String",
  DATE_TIME = "Date",
  INT = "Integer",
  DECIMAL = "Decimal",
  BOOLEAN = "Bool",
  CUSTOM = "Custom",
}

export enum ValueType {
  SP = "SP",
  VALUE = "VALUE",
}
